import styled from 'styled-components'

export const SubmitButtonBlock = styled.div`
  display: block;
  margin-top: ${props => (props.marginTop ? '20px' : 0)};
  float: ${props => props.float || 'right'};
`
